import { render, staticRenderFns } from "./duty-edit-modal.vue?vue&type=template&id=176c9704&scoped=true"
import script from "./duty-edit-modal.vue?vue&type=script&lang=js"
export * from "./duty-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./duty-edit-modal.vue?vue&type=style&index=0&id=176c9704&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176c9704",
  null
  
)

export default component.exports